(function() {
  const container = document.querySelector('.starter-offer-selects');
  if (!container) return;
  const hasFrequency = container.dataset.hasFrequency === 'true';

  const state = {
    flavour1: null,
    flavour2: null,
    frequency: null
  };

  const setDefaultFrequency = () => {
    const defaultOption = container.querySelector(
      '[data-select-id="frequency"] .starter-offer-option[data-default="true"]'
    );
    const fallbackOption = container.querySelector(
      '[data-select-id="frequency"] .starter-offer-option'
    );
    const fourWeekOption = Array.from(
      container.querySelectorAll('[data-select-id="frequency"] .starter-offer-option')
    ).find(option => {
      const labelEl = option.querySelector('.starter-offer-option-text');
      const label = labelEl ? labelEl.textContent.toLowerCase() : '';
      return label.includes('4 week');
    });

    const targetOption = defaultOption || fourWeekOption || fallbackOption;

    if (!targetOption) return;

    const triggerText = container.querySelector(
      '[data-select-id="frequency"] .starter-offer-trigger-text'
    );
    const labelEl = targetOption.querySelector('.starter-offer-option-text');
    const label = labelEl ? labelEl.textContent : '';
    state.frequency = {
      value: targetOption.dataset.frequency,
      planId: targetOption.dataset.planId,
      label
    };
    if (triggerText && label) triggerText.textContent = label;
  };

  const closeAll = () => {
    container.querySelectorAll('.starter-offer-options').forEach(opt => {
      opt.classList.remove('is-open');
      const trigger = opt.previousElementSibling;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const updateUI = () => {
    const button = container.querySelector('[data-add-to-cart]');
    const helper = container.querySelector('[data-helper]');
    const helperMsg = container.querySelector('[data-helper-msg]');
    const ready = Boolean(state.flavour1 && state.flavour2 && (!hasFrequency || state.frequency));

    button.disabled = !ready;
    if (helper) helper.classList.toggle('is-ready', ready);
    if (helperMsg) {
      helperMsg.textContent = ready
        ? 'YOU HAVE UNLOCKED A FREE BOTTLE!'
        : 'Add any 2 boxes for the free bottle';
    }
  };

  container.addEventListener('click', e => {
    const trigger = e.target.closest('.starter-offer-trigger');
    const option = e.target.closest('.starter-offer-option');

    if (trigger) {
      const select = trigger.parentElement;
      const options = select.querySelector('.starter-offer-options');
      const isOpen = options.classList.contains('is-open');
      closeAll();
      if (!isOpen) {
        options.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    if (option) {
      const select = option.closest('.starter-offer-select');
      const selectId = select.dataset.selectId;
      const triggerText = select.querySelector('.starter-offer-trigger-text');
      const thumbEl = select.querySelector('.starter-offer-trigger > .starter-offer-thumb');

      if (selectId === 'flavour1' || selectId === 'flavour2') {
        const handle = option.dataset.handle;
        const boxId = option.dataset.boxId;
        const name = option.querySelector('.starter-offer-option-text').textContent;
        const img = option.querySelector('img');
        const image = img ? img.src : '';
        const plans = option.dataset.productPlans || '';

        state[selectId] = { handle, boxId, name, image, plans: plans.split(',').filter(Boolean) };
        triggerText.textContent = name;

        if (thumbEl && image) {
          thumbEl.innerHTML = `<img src="${image}" alt="${name}">`;
          select.classList.remove('starter-offer-select--thumb-empty');
        }
      } else if (selectId === 'frequency' && hasFrequency) {
        const value = option.dataset.frequency;
        const planId = option.dataset.planId;
        const label = option.querySelector('.starter-offer-option-text').textContent;
        state.frequency = { value, planId, label };
        triggerText.textContent = label;
      }

      closeAll();
      updateUI();
    }
  });

  document.addEventListener('click', e => {
    if (!container.contains(e.target)) closeAll();
  });

  container.querySelector('[data-add-to-cart]').addEventListener('click', async function(evt) {
    if (!state.flavour1 || !state.flavour2 || (hasFrequency && !state.frequency)) return;

    const button = evt.currentTarget;
    const giftId = Number(button.dataset.productGift);
    const existGiftInCart = window?.Rebuy?.Cart?.items()?.some(item => item.id === giftId);

    this.disabled = true;
    const selectedFrequency = hasFrequency ? state.frequency : null;
    const items = [state.flavour1, state.flavour2].map(item => {
      const payload = { id: item.boxId, quantity: 1, properties: { _starter_pack: true } };
      if (
        selectedFrequency &&
        selectedFrequency.planId &&
        item.plans.includes(selectedFrequency.planId)
      ) {
        payload.selling_plan = selectedFrequency.planId;
      }
      return payload;
    });

    if (!existGiftInCart && giftId) items.push({ id: giftId, quantity: 1});
    
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (r.ok) {
        document.dispatchEvent(new CustomEvent('rebuy:cart.add', { detail: { items } }));
        document.dispatchEvent(new CustomEvent('rebuy:smartcart.show'));
      }
    } catch (e) {}
    this.disabled = false;
  });

  if (hasFrequency) setDefaultFrequency();
  updateUI();
})();
